import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Abstract authentication service.
 * Provides a complete interface for authentication management that can be implemented
 * differently for production (OAuthService) and mock environments (MockService).
 *
 * Handles both low-level auth checks and high-level auth flow management.
 */
@Injectable()
export abstract class AuthService {
  // ===== Low-Level Auth Checks =====
  abstract hasValidAccessToken(): boolean;
  abstract getAccessToken(): string | null;

  // ===== High-Level Auth Flow Management =======
  abstract readonly isLoggedIn$: BehaviorSubject<boolean>;
  abstract readonly isAdmin$: BehaviorSubject<boolean>;
  abstract readonly userRoles$: BehaviorSubject<string[]>;
  abstract readonly displayName$: BehaviorSubject<string>;

  abstract init(): void;
  abstract login(): void;
  abstract logout(): void;
  abstract getIsLoggedIn$(): BehaviorSubject<boolean>;
  abstract getIsAdmin$(): Observable<boolean>;
}
